/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class Precision {
  id: string;
  unit: string;
  precision: number;
  tenantId?: string;
}
